import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { READ_ONLY_MODE, READ_ONLY_PHRASE } from '../../src/env';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import { YOUNG_PROFESSIONALS_PLAN } from '../../utils/subscriptionCardOptions';
import { CustomToaster } from '../BaseUI';
import PaymentForm from './PaymentForm';
import SignupForm from './SignupForm';

const queryClient = new QueryClient();

export interface SubscriptionFormProps {
  buttonText: string;
  currentTrialEndDate?: string;
  dob?: string;
  isUserCBPT?: boolean;
  referringSubscriberGuid?: string;
  referringSubscriberName?: string;
  selectedOffer: SelectedOffer;
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
  userNextBillingDate?: string;
}

const SubscriptionForm = (props: SubscriptionFormProps) => {
  const [stripeCustomerId, setStripeCustomerId] = useState(props.stripeCustomerId);
  const [dob, setDob] = useState(props.dob);
  const [hidePaymentForm, setHidePaymentForm] = useState(false);

  useEffect(() => {
    if (props.selectedOffer.code.includes(YOUNG_PROFESSIONALS_PLAN) && !dob) {
      setHidePaymentForm(true);
    } else {
      setHidePaymentForm(false);
    }
  }, [props.selectedOffer, dob]);

  return (
    <div>
      {READ_ONLY_MODE ? (
        <div className="warning tw-mt-28">
          <h3>Purchases are temporarily unavailable</h3>
          Sorry, we&apos;re doing some necessary site maintenance now, and this feature isn&apos;t
          available. Please try again in {READ_ONLY_PHRASE || '10-15 minutes'}. Thanks for your
          patience!
        </div>
      ) : (
        <QueryClientProvider client={queryClient}>
          <SignupForm
            {...props}
            dob={dob}
            initialDob={props.dob}
            setDob={setDob}
            setStripeCustomerId={setStripeCustomerId}
          />
          {stripeCustomerId && !hidePaymentForm && (
            <PaymentForm {...props} stripeCustomerId={stripeCustomerId} />
          )}
          <CustomToaster />
        </QueryClientProvider>
      )}
    </div>
  );
};

export default SubscriptionForm;
